import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Call from "../../assets/img/custommer_call.png";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import Footer from "../Footer/Footer";
import { FaThreads } from "react-icons/fa6";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ContactUs = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Header */}
      <NoZoomWrapper>
        <NoCopyWrapper>
          <div className="contact-header">
            <IoIosArrowBack
              className="back-icon"
              onClick={() => navigate(-1)}
            />
            <h1>Contact Us</h1>
          </div>

          {/* Content */}
          <div className="container">
            <div className="customer">
              <img className="cair" src={Call} />
            </div>
            <div className="center-wrapper">
              <div className="contact-card">
                {/* Contact Items */}
                <div className="contact-item">
                  <div>
                    <h3>Call request</h3>
                    <p>+91 99799 55319</p>
                  </div>
                  <IoIosArrowForward />
                </div>

                <div
                  className="contact-item"
                  onClick={() =>
                    window.open("https://wa.me/919979955319", "_blank")
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <h3>Whatsapp Us</h3>
                    <p>+91 99799 55319</p>
                  </div>
                  <IoIosArrowForward />
                </div>

                <div
                  className="contact-item"
                  onClick={() =>
                    window.open(
                      "mailto:contact@rentel.in?subject=Support&body=Hi Rentel,",
                      "_blank"
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="clickon">
                    <h3>Email</h3>
                    <p>Response within 24 business hours</p>
                  </div>
                  <IoIosArrowForward />
                </div>

                {/* Follow Us */}
                <div className="follow-section">
                  <h3>Follow Us</h3>
                  <div className="social-iconsd">
                    <a
                      href="https://www.facebook.com/profile.php?id=61584278505265"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaFacebookF />
                    </a>
                    <a
                      href="https://www.instagram.com/rentel.in/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaInstagram />
                    </a>
                    <a
                      href="https://www.threads.com/@rentel.in"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaThreads />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default ContactUs;
